module.exports = __webpack_public_path__ + "img/sfbuy.cc58a94.jpg";